export default __webpack_public_path__ + "static/150-e14ca454df48ed6ac559adef2799a3cb.jpg";